import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeader } from './ui/SectionHeader';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-white" data-id="element-41" data-mp="1nwvwmzb64jqt">
      <div className="mx-auto max-w-2xl px-4 py-4 sm:py-8" data-id="element-42" data-mp="2blf4jdqb2uid">
        <SectionHeader id="faq" title="Preguntas frecuentes" data-id="element-43" data-mp="2flxut3cjvsig" />
        <div className="mt-3 space-y-1.5" data-id="element-44" data-mp="2fl615y2ik4ut">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className={`rounded-lg border bg-mist transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'border-brand' : 'border-navy/10'}`} data-id="element-45" data-mp="26tdrhplbczra" data-mpi={i}>
                <h3 data-id="element-46" data-mp="2zc1bf1okq8qs">
                  <button type="button" id={`faq-trigger-${i}`} onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 rounded-lg px-3 py-2.5 text-left" data-id="element-47" data-mp="1vphvk3jirzuy">
                    <span className="font-condensed text-[0.95rem] font-bold text-navy" data-id="element-48" data-mp="2fdi84dxk2mfk">{faq.q}</span>
                    <ChevronDownIcon size={16} aria-hidden="true" className={`flex-shrink-0 text-brand transition-transform duration-200 ease-[cubic-bezier(0.23,1,0.32,1)] ${isOpen ? 'rotate-180' : ''}`} data-id="element-49" data-mp="2aexi17c0pj4u" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-50" data-mp="p1cbr0voaiuu">
                  {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-trigger-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-51" data-mp="p3fduja3o2fx">
                      <p className="px-3 pb-2.5 text-[0.8rem] leading-snug text-navy/75 sm:text-sm" data-id="element-52" data-mp="3826a48t47cnq">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}